var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-card',{staticClass:"light h-100",staticStyle:{"cursor":"pointer"},attrs:{"elevation":"2"}},[_c('div',{staticClass:"d-flex align-center primary--text justify-center h-100 py-10 px-4"},[_c('v-icon',{attrs:{"large":""}},[_vm._v("mdi-plus")]),_c('span',{staticClass:"h3 primary--text bold ml-3"},[_vm._v("Otro")])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }